import TextArea from "./TextArea";
const Markdown = () => {
  return (
    <>
      <main className="markdown">
        <TextArea />
      </main>
    </>
  );
};

export default Markdown;
